import FormHeader from "../../forms/auth/FormHeader";
import PasswordResetForm from "../../forms/auth/PasswordResetForm";
import { useResetPassword } from "../../../hooks/useUser";
import { useEffect, useMemo } from "react";
import { useToast } from "@chakra-ui/react";
import { toastSuccess } from "../../../lib/toastDetails";

function PasswordReset({ type }) {
  const toast = useToast();
  const { mutate, isLoading, isSuccess, isError, error, data } =
    useResetPassword(type);

  const receivedData = useMemo(() => data, [data]);

  useEffect(() => {
    if (isSuccess) {
      toast(toastSuccess(receivedData));
    }
  }, [isSuccess, receivedData, toast]);

  return (
    <>
      <FormHeader
        title={
          type === "setPassword"
            ? "Request Password Reset Link"
            : "Recover Password"
        }
        subtitle={
          type === "setPassword"
            ? "Please enter the email that you used to create your account and new reset link will be shared to your email."
            : "A link will be shared to your email"
        }
      />
      <PasswordResetForm
        onSubmit={mutate}
        isSubmitting={isLoading}
        isError={isError}
        error={error}
        type={type}
      />
    </>
  );
}

export default PasswordReset;
